import { CheckboxGroup as CheckboxGroupComponent } from "../../CheckboxGroup";
import { CheckboxGroupProps } from "../types";
import { withFormField } from "./withFormField";

export const CheckboxGroup = withFormField<CheckboxGroupProps>(
  CheckboxGroupComponent as React.ComponentType<CheckboxGroupProps>,
);
